import React from "react";
import styles from "./styles/InputCheck.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../utils/utils";
/**
 * Checkbox component
 */
const InputCheck = ({
    label, // {String} - The label text for the input
    inputId, // {String} - The ID of the input element
    inputValue, // {Boolean} - The value of the input element
    handleChangeFunction, // {Function} - The function to handle input changes
    required, // {Boolean} - Flag to indicate if the input is required
    labelLinkURL,
    labelLinkBody,
    sideMenuCheck,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div
            className={`${styles.input_container} ${
                sideMenuCheck ? styles.side_continer : ""
            } flex-container`}
        >
            <input
                className={`${styles.input_element}`}
                type="checkbox"
                name={inputId}
                id={inputId}
                value={inputValue}
                checked={inputValue}
                onChange={handleChangeFunction}
            />
            <label
                className={`${styles.input_label} ${
                    required ? styles.label_red : ""
                } ${sideMenuCheck ? styles.dark_text : ""}`}
                htmlFor={inputId}
            >
                {label ? `${capitalizeFirstLetter(label)} ` : ""}
                {labelLinkURL ? (
                    <NavLink
                        className={`${styles.label_link} ${
                            required ? styles.label_red : ""
                        }`}
                        to={labelLinkURL}
                        state={{ fromApp: true }}
                        aria-label={`link to ${label}`}
                        // target={null}
                        // rel={null}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {labelLinkBody}
                    </NavLink>
                ) : (
                    ""
                )}
            </label>
        </div>
    );
};

export default InputCheck;
